import { supabaseClient } from "@/lib/supabase";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import useInvalidateDiaries from "../../diaries/features/edit/api/invalidateDiaries";

const deleteEvent = async (eventId: string) => {
	return supabaseClient
		.from("events")
		.delete()
		.eq("event_id", eventId)
		.throwOnError();
};

export const useDeleteEventMutation = (diaryId: string) => {
	const invalidateDiary = useInvalidateDiaries();
	return useMutation({
		mutationKey: ["delete-event"],
		mutationFn: async (eventId: string) => {
			return await deleteEvent(eventId);
		},
		onError: (error) => {
			toast.error(`${error.message}`);
		},
		onSuccess: () => {
			toast.success("Event deleted successfully");
			invalidateDiary(diaryId);
		},
	});
};
export default useDeleteEventMutation;
